module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/KXfwBrZRCeECOsg6YMWSI-b7433a6dc4728df8016af8f13cabc719.jpg";